var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('ali-player',{attrs:{"source":_vm.source,"autoplay":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }